<script>
// Custom Components
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";
import PageHeader from "@/components/page-header.vue";
import middlewares from "@/helpers/middlewares";

export default {
  name: "server_health",
  data() {
    return {
      title: "Server Health",
      table: {
        tableData: [],
      },

      isDataLoading: true,
    };
  },
  components: {
    PageHeader,
  },
  mounted() {
    this.getServerHealthList();
  },
  methods: {
    // Method is used to list of fax number
    getServerHealthList() {
      this.isDataLoading = true;
      const providerId = process.env.SKYETEL_PROVIDER_ID;
      PbxService.getServerHealthList(providerId, {
        action: "get-trunk-iphealth",
      })
        .then((response) => {
          if (response.status == false) {
            return middlewares.notification(response.message, "warning");
          }
          this.table.tableData = response.result;
          this.isDataLoading = false;
        })
        .catch((error) => {
          this.isDataLoading = false;
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="getServerHealthList"
      text="Referesh"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Server Name</th>
              <th>Ip Address</th>
              <th>Classic Regions</th>
              <th>Regions 2.0</th>
              <th>Fraud Alerts</th>
              <th>Updatime Alerts</th>
            </tr>
          </thead>
          <tbody v-if="isDataLoading">
            <tr v-for="no in 10" :key="no">
              <td class="placeholder-glow" v-for="no in 6" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(item, index) in table.tableData" :key="index">
              <td>
                {{ item.description }}
              </td>
              <td>
                {{ item.ip }}
              </td>
              <td>
                <i
                  class="me-2 fs-4"
                  :class="
                    item[`region${no}`]
                      ? 'fas fa-arrow-circle-up text-success'
                      : 'fas fa-arrow-circle-down text-danger'
                  "
                  v-b-popover.hover="
                    no == 1
                      ? `North West : ${item[`region${no}`] ? 'Up' : 'Down'}`
                      : no == 2
                      ? `South West :  ${item[`region${no}`] ? 'Up' : 'Down'}`
                      : no == 3
                      ? `South East :  ${item[`region${no}`] ? 'Up' : 'Down'}`
                      : `North East :  ${item[`region${no}`] ? 'Up' : 'Down'}`
                  "
                  v-for="no in 4"
                  :key="no"
                ></i>
              </td>
              <td>
                <i
                  class="me-2 fs-4"
                  :class="
                    item[`region${no}a`]
                      ? 'fas fa-arrow-circle-up text-success'
                      : 'fas fa-arrow-circle-down text-danger'
                  "
                  v-b-popover.hover="
                    no == 1
                      ? `North West : ${item[`region${no}a`] ? 'Up' : 'Down'}`
                      : no == 2
                      ? `South West :  ${item[`region${no}a`] ? 'Up' : 'Down'}`
                      : no == 3
                      ? `South East :  ${item[`region${no}a`] ? 'Up' : 'Down'}`
                      : `North East :  ${item[`region${no}a`] ? 'Up' : 'Down'}`
                  "
                  v-for="no in 4"
                  :key="no"
                ></i>
              </td>
              <td>
                <span class="text-primary"
                  >{{ item.channel_threshold }} channels
                </span>
              </td>
              <td>
                <div class="form-check form-switch my-1" slot="is_active">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="item.alert"
                    disabled
                  />
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!isDataLoading && table.tableData.length == 0">
            <tr>
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>
